import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, FormsModule } from '@angular/forms';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { interval } from 'rxjs';
import { debounce } from 'rxjs/operators';

@Component({
  selector: 'app-party-attribute-interval-restriction',
  templateUrl: './party-attribute-interval-restriction.component.html',
  styleUrls: ['./party-attribute-interval-restriction.component.scss'],
})
export class PartyAttributeIntervalRestrictionComponent implements OnInit {
  @Input() partyAttributeIntervalRestriction: any;
  units: any;
  conditions: any;
  inclusionValues: any;
  faTimes = faTimes;
  faPlus = faPlus;
  @Output() public inputChangeEmitter: EventEmitter<any> = new EventEmitter(true);
  debouncer: Subject<string> = new Subject<string>();

  constructor(
    private router: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private formsModule: FormsModule,
    private modalHelper: NgbModal
  ) {
    this.debouncer.pipe(debounce(() => interval(1000))).subscribe((value) => this.inputChangeEmitter.emit(value));
  }

  ngOnInit(): void {
    this.conditions = [
      { value: true, text: 'true' },
      { value: false, text: 'false' },
    ];

    this.units = [
      { value: 'YEAR', text: 'YEAR' },
      { value: 'MONTH', text: 'MONTH' },
      { value: 'WEEK', text: 'WEEK' },
      { value: 'DAY', text: 'DAY' },
    ];

    this.inclusionValues = [
      { value: 'strict', text: 'strict' },
      { value: 'permissive', text: 'permissive' },
    ];
  }

  initRestrictionObject(): void {
    console.log(this.partyAttributeIntervalRestriction);
    var tmpObj = {
      class:
        'com.chiprewards.cheetah.business.rules.config.behavior.v2.BehaviorConfiguration$Restrictions$Behavioral$PartyAttributeInterval',
    };
    if (this.partyAttributeIntervalRestriction) {
      this.partyAttributeIntervalRestriction.push(tmpObj);
    } else {
      this.partyAttributeIntervalRestriction = [];
      this.partyAttributeIntervalRestriction.push(tmpObj);
    }
  }

  updateRestrictions() {
    this.debouncer.next(this.partyAttributeIntervalRestriction);
  }

  removeRestriction(restriction) {
    this.partyAttributeIntervalRestriction.splice(this.partyAttributeIntervalRestriction.indexOf(restriction), 1);
    this.updateRestrictions();
  }
}
